import { headerNotifications } from "../../constants/actionTypes";
import { emptyList } from "../../constants/componentConstants";

const INITIAL_STATE = {
  userNotificationList: emptyList,
  usernotificationListError: "",
  userNotificationReadStatus: "",
  updatedUserNotification: emptyList,
};

const resourceManager = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case headerNotifications.USER_NOTIFICATION_LIST_SET_DATA:
      return {
        ...state,
        userNotificationList: {
          ...action?.payload?.data,
        },
      };
    case headerNotifications.USER_NOTIFICATION_LIST_SET_DATA_WS:
      return {
        ...state,
        updatedUserNotification: {
          ...action?.payload,
        },
      };
    case headerNotifications.USER_NOTIFICATION_LIST_SET_ERROR:
      return {
        ...state,
        usernotificationListError: action?.payload?.response,
      };
    case headerNotifications.USER_NOTIFICATION_READ_STATUS_SUCCESS:
      return {
        ...state,
        userNotificationReadStatus: {
          ...action?.payload?.data,
        },
      };
    case headerNotifications.USER_NOTIFICATION_READ_STATUS_FAILURE:
      return {
        ...state,
        userNotificationReadStatus: {
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default resourceManager;
